module.exports = __webpack_public_path__ + "img/new_17_1.c448ba90.jpg";